import { BASE_URL, CANDIDATE_JOB_SEARCH, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${CANDIDATE_JOB_SEARCH}`; 


export const fetchJobsByKeywords = async (experience, locations, skills, titles, company) => {
  // Create a base object with only non-empty values
  const queryObject = {
    ...(experience ? { experience } : {}),
    ...(locations?.length ? { locations: JSON.stringify(locations) } : {}),
    ...(skills?.length ? { skills: JSON.stringify(skills) } : {}),
    ...(titles?.length ? { titles: JSON.stringify(titles) } : {}),
    ...(company?.length ? { company: JSON.stringify(company) } : {}),
  };
  

  // Construct the query string from the filtered object
  const query = new URLSearchParams(queryObject).toString();
  const url = `${API_BASE_URL}?${query}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Response data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching jobs:", error);
    throw error;
  }
};

